import { createFileRoute } from '@tanstack/react-router'
import { ValueStoryEdit } from 'pages/valueStories/ValueStoryEdit'
import { valueStorySearchParams } from 'routes/value-stories/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId, valueStoryId } = Route.useSearch()

  return (
    <ValueStoryEdit orgId={orgId} siteId={siteId} valueStoryId={valueStoryId} />
  )
}

export const Route = createFileRoute('/value-stories/edit')({
  component: RouteComponent,
  staticData: {
    title: 'Edit Value Story',
    layout: {
      enableScrolling: true,
      showNavbar: true,
    },
  },
  validateSearch: valueStorySearchParams,
})
